import { getCookie, setCookie } from '../utils/cookies.js';
import { isApp } from '../utils.js';
import { track } from './bi-track.js';
import { user } from '../utils';
import { StartSessionBIModel } from '../BI/models';

if(!getCookie('apdt') && !isApp()) {
    const sessionId = typeof window.crypto.randomUUID !== 'undefined' ?  window.crypto.randomUUID() : Math.random().toString(36).slice(2);
    setCookie(
        'apdt',
        sessionId,
        1800//media hora
    );
    track(new StartSessionBIModel(user? user.id : -1));
}